import React from "react";
import { DataGrid, gridClasses, GridToolbar } from "@mui/x-data-grid";
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Button,
  Alert,
  AlertTitle,
  Typography,
  Snackbar,
} from "@mui/material";
import FireIcon from "@mui/icons-material/LocalFireDepartment";
import Grid2 from "@mui/material/Unstable_Grid2"; // Grid version 2
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";
import Tooltip from "@uiw/react-tooltip";
import HeatMap from "@uiw/react-heat-map";
import quotes from "./positive_quotes";
import { LooksOne, ThumbUpOffAlt } from "@mui/icons-material";
import { format } from "date-fns";
import AnimatedNumbers from "react-animated-numbers";

export default function DailyEarnDetails2024(props) {
  //console.log("daily goals props", props);
  /*   [...new Set(props.studentDataByDay.filter(x=>x.onegoal_points > 0).map(x=>
    console.log(new Date(x.instructional_day.value).valueOf())
    //new Date(x.instructional_day.value)

    ))] */

  /*   console.log("oldest in a row from today", 
  props
  .studentDataByDay
  .filter(x=>x.onegoal_points < 2 && x.onegoal_points > 0 && x.onegoal_points != null)
  .sort((a,b)=> b.instructional_day.value.valueOf() - a.instructional_day.value.valueOf() )
  .slice(-1)[0].instructional_day.value,

  "time of this",

  new Date(props
  .studentDataByDay
  .filter(x=>x.onegoal_points < 2 && x.onegoal_points > 0 && x.onegoal_points != null)
  .sort((a,b)=> b.instructional_day.valueOf() - a.instructional_day.valueOf() )
  .slice(-1)[0].instructional_day.value)
  .getTime(),

  "diff in days",

  Math.floor((new Date().getTime() - new Date(props
  .studentDataByDay
  .filter(x=>x.onegoal_points < 2 && x.onegoal_points > 0 && x.onegoal_points != null)
  .sort((a,b)=> b.instructional_day.value.valueOf() -a.instructional_day.value.valueOf() )
  .slice(-1)[0].instructional_day.value).getTime())
  /(1000 * 3600 * 24)-1)

  ) */

  const [showDailyData, setShowDailyData] = React.useState(false);
  const [behaviorStreak, setBehaviorStreak] = React.useState(0);
  const [openBehavior, setOpenBehavior] = React.useState(false);
  const [chartDataBehavior, setChartDataBehavior] = React.useState([]);
  const [selected, setSelected] = React.useState("");
  const [selectedTitle, setSelectedTitle] = React.useState("");

  // ms students that finished pfas early received bonus
  const students_earning_bonus = ['50380350','50458702','50517089','50377776','50381185','50442814','50446374','50532778','50408088','50323979','50487467','60086909','50604569','50380194','50755693','50525981','50449073','50410005','50536573','50423108','50365806','50437028','50631938','50394244','50531611','50476730','50383107','50538853','50394250','50561919','50380958','50367256','50528581','50377310','50414921','60132136','50377622',
  '50559573','50382829','50525995','50532876','50378361','50552289','50603595','50410801','50444873','50382778','50472566','50385447','50380388','50518185','50524642','50532831','50439112','50383150','50545299','50379071','50516210','50451496','50575535','50397951','50531685','50377215','50381043','50445538','50363389','50341870','50383573','50322847','50447711','50526042','50534780','50751970','50377898','50579552','50380193','50378523',
  '50609454','50492286','50427524','50445065','50382876','50380703','50475479','50365807','50448948','50394229','50553258','50504668','50532815','50545038','50549600','60107698','60075952','50478771','50381132','50414082','50491346','50412189','50527222','50445306','50376719','50379310','50542103','50385465','50538330']

  // ms students that were present on both 1/30 and 1/31/24
  const students_earning_bonus_2 = ['50532815', '50525995', '50446374', '50531685', '50534780', '50385465', '50397951', '50579552', '50603595', '50490727', '60029298', '50487467', '50381043', '50380958', '50518185', '50561919', '60208664', '50516129', '50377310', '50445894', '50381132', '50536573', '50408088', '50380193', '50341870', '50437028', '60134505', '60087587', '50545299', '50545510', '50412189', '50379310', '50472566', '60107698',
   '50394244', '50410005', '50538178', '50392809', '50478771', '50491346', '50439112', '50492286', '50445065', '50377776', '50449073', '50385825', '50414082', '50322847', '50380703', '50538653', '50365806', '50532831', '50383573', '60234410', '50532778', '50445538', '50592257', '50363389', '60132136', '50383107', '50380388', '50450403', '50609454', '50604569', '50545038', '50379071', '50549600', '60115121', '50575535', '50751970', '50394229',
    '50383150', '50381011', '50458702', '50538853', '50376944', '50380350', '60075952', '50382876', '61988093', '50423108', '50538330', '50376719', '50755693', '50323979', '50559573', '50377215', '50365807', '50524642', '50382778', '50525981', '50394250', '50381185', '50367256', '50448948', '50402010', '50445306', '50377898',
   '50444873', '50506478', '50442814', '50531611', '50484975', '50553258', '50451496', '50385447', '60086909', '50414921', '50378523', '50447711', '50516210', '60712824', '50427524', '50631938', '60203447', '50384076', '50313138', '50471976', '50376690', '50421912', '50476405', '50381382', '50383086', '50336288', '50510084', '50391804', '50375902', '50376977', '60191946', '50265753', '50566036', '50658967', '50184829', '50381208', '50335130',
    '50355148', '50331590', '50395247', '50335691', '50394412', '50413990', '50365067', '50465677', '50362714', '50434910', '50366646', '50393272', '50380932', '50381122', '50340019', '50382155', '50359211', '50384373', '50382972', '50471228', '50394230', '50263601', '50325694', '50329275', '50319110', '50382706', '60134082', '50333279', '50376718', '50474926', '50394140', '50329282', '50461553', '50381368', '50460362', '50465866', '50463797',
     '50430814', '50460348', '50460299', '50331716', '50272732', '50461485', '50358620', '50634213', '60151718', '60194889', '50352504', '50333809', '50325643', '50345286', '50476193', '50363534', '50311189', '50381951', '50373360', '50384882', '50335779', '50431090', '50471283', '50379124', '50336286', '50274675', '50392755',
    '50395182', '50460356', '60194301', '50436677', '50461389', '50310560', '50358872', '50459982', '50383488', '50504059', '50400674', '50379108', '50379774', '50314110', '50454343', '50352748', '50273786', '50323832', '50333643']


    //8th grade advisory week of 3/4 first prize
    const students_earning_first_prize = ['50510084', '50461553', '50273786', '50461389', '50379124', '50352504', '50381122', '50337587', '50365382', '50413990', '50471976', '50335691', '50460585', '50394140', '50311189', '50431090', '50477538', '50358872', '50480534', '50406963', '50313138', '50434910', '50375876', '50400674', '50265753', '50333279']

    const students_earning_second_prize = ['50460299', '50382706', '50366646', '50406505', '50469737', '50454343', '50358620', '50436677', '50352748', '50461485', '50379774', '50393272', '50381382', '50335130', '50336286', '50474450', '50333809', '50458325', '50340019', '50476193', '50383086', '50335779', '50460356', '50325694', '50331590', '50384076', '50392755']
    
    const students_earning_third_prize = ['50394412', '60151718', '60191946', '50381208', '50376718', '50323832', '50380932', '50479730', '50310560', '50658967', '50184829', '50566036', '50476405', '50471228', '50359211', '50379108', '50376977', '60164067', '50373360', '50365067', '50340947', '60000416', '50333643', '50376690', '50358700', '50634213', '50394665', '50381951', '50438248', '50329275']
  
    const juniors_earning_bonus = ['50261691','50287305','50223272','50618905','50220164','50212687','50283331','50222834','50088116','50220899','50091164','50220939','50221763','50345940','50221050','50190314','50283084','50220744','50283735','50283595','50224362','50084444','50124388','50295715','50270223','50243868','50283208','50217859','50222671','50285704','50283038',
    '50220868','50211693','50283723','50293904','50287301','50112961','50258703','50219871','50296566','50212447','50710433','50202706','50154453','50295702','50163495','50500199','50267418','50220851','50217812','50296920','50220684','50128370','50193839','50283238','50206468','50261779','50293227','50163729','50286766','50212044','50295215']
    
    // zero hero belmont 50 points prize

    const zero_hero = ['50402010', '50609454', '50381011', '50545038', '50458702', '50380350', '50517089', '60712824', '50447711', '50484975', '50478771', '50534780', '50380703', '50449073', '50385447', '50385825', '50380193', '50423108', '50524642', '50553258', '50363534', '50331716', '50382972', '50329282', '50383488', '50471976', '50395247', '50373360', '50329275', '50355148', '50237019', '50376718', '50384076', '50431090',
     '50379774', '50471283', '50376371', '50261880', '50347701', '50333765', '50307189', '50286281', '50305738', '50309922', '50331731', '50404642', '50280624', '50276603', '50333987', '50400004', '50335126', '50333520', '50223023', '50253470', '50247197', '50711751', '50573150', '50212034', '50275499', '50571217', '50253669', '50267666', '50355284', '50217349', '50282009', '50279670', '50197464', '50310111', '50276286', '50575538',
      '50344585', '50299615', '50242942', '50309174', '50219326', '60037351', '50348195', '50218591', '50199792', '50199791', '60133638', '50193589', '50340574', '50557768', '50225715', '50275671', '50220164', '50221050', '50710433', '50220868', '50212687', '50171216', '50211693', '50270223', '50190314', '50287305', '50220744', '50220899', '50268443', 
    '50088116', '50202706', '50154453', '50293227', '50243868', '50224362', '50283238', '50219871', '50500199', '50287301', '50084444', '50285704', '50220939', '50206468', '50220851', '50618905', '50345940', '50212447', '50367572', '50236687', '50214456', '50097887', '50226038', '50528970', '50163984', '50229269', '50238333', '50677402', '50163949', '50675186', '50194591', '45625311', '50186213', '50239381', '50571312', '50684376']

    const handleClickBehavior = () => {
    setOpenBehavior(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenBehavior(false);
  };

  React.useEffect(() => {
    get_streak(props.studentDataByDay, "behavior");

    const map_data_behavior =
      props.studentDataByDay.length === 0
        ? null
        : props.studentDataByDay.map((row) => {
            let data = {
              date: new Date(row.instructional_day.value + " CST"),
              count: row.onegoal_points,
              infractions: row.daily_total_infractions
                ? row.daily_total_infractions
                : 0,
              attendance:
                row.school_attendance_event_category_descriptor === null
                  ? "No attendance data"
                  : row.school_attendance_event_category_descriptor,
              status:
                row.school_attendance_event_category_descriptor +
                `; ${
                  row.daily_total_infractions ? row.daily_total_infractions : 0
                }  infractions` +
                `; ${
                  row.onegoal_points ? row.onegoal_points : 0
                }  points earned`,
            };
            return data;
          });

    setChartDataBehavior(map_data_behavior);
  }, []);

  const get_streak = (data, type) => {
    //console.log("start streak", type, data)
    const clone_data = data.length === 0 ? null : data.slice(0);

    const sorted_data = clone_data.sort(
      (a, b) =>
        new Date(b.instructional_day.value) -
        new Date(a.instructional_day.value)
    );
    //console.log("original",sorted_data[0].consecutive_school_day)
    /*     console.log(Math.max(
      ...[
        ...new Set(
          props.studentDataByDay.map((x) => x.consecutive_school_day)
        ),
      ]
    ),
      (sorted_data[0].consecutive_school_day === 1
        ? 0
        : sorted_data[0].consecutive_school_day)) */

    try {
      if (
        type === "behavior" &&
        sorted_data[0].onegoal_points > 0 && // behavior points are not zero
        sorted_data[0].consecutive_school_day > 1 // it is not the first day of school
      ) {
        //console.log("repeat process")
        get_streak(sorted_data.splice(1), type); //repeat process
      } else {
        //console.log( "streak start date",  type, sorted_data[0].consecutive_school_day )
        setBehaviorStreak(
          Math.max(
            ...[
              ...new Set(
                props.studentDataByDay.map((x) => x.consecutive_school_day)
              ),
            ]
          ) -
            (sorted_data[0].consecutive_school_day === 1 &&
            sorted_data[0].onegoal_points > 0
              ? 0
              : sorted_data[0].consecutive_school_day)
        );
      }
    } catch (err) {
      console.error(err);
      return 0;
    }
  };

  return props.studentDataByDay.length === 0 ? null : (
    <Grid2 container>
            <Grid2 id="data last updated" item xs={12} xl={12}>

            {zero_hero.includes(props.studentDataByDay[0].student_unique_id) ?
<React.Fragment><Alert
severity="success"
>
{"You earned an extra 50 points for earning 0 infractions in semester 1 of 23-24 school year!"}</Alert>
 <Box m={2}/>
 </React.Fragment>
: null 
}

            {students_earning_first_prize.includes(props.studentDataByDay[0].student_unique_id) ?
<React.Fragment><Alert
severity="success"
>
{"You earned an extra 20 points for being a part of the first prize winning advisory team during the week of March 3!"}</Alert>
 <Box m={2}/>
 </React.Fragment>
: null 
}

{students_earning_second_prize.includes(props.studentDataByDay[0].student_unique_id) ?
<React.Fragment><Alert
severity="success"
>
{"You earned an extra 15 points for being a part of the second prize winning advisory team during the week of March 3!"}</Alert>
 <Box m={2}/>
 </React.Fragment>
: null 
}

{students_earning_third_prize.includes(props.studentDataByDay[0].student_unique_id) ?
<React.Fragment><Alert
severity="success"
>
{"You earned an extra 10 points for being a part of the third prize winning advisory team during the week of March 3!"}</Alert>
 <Box m={2}/>
 </React.Fragment>
: null 
}

{juniors_earning_bonus.includes(props.studentDataByDay[0].student_unique_id) ?
  <React.Fragment><Alert
severity="success"
>
{"On 4/10/24 you earned an extra 20 points for arriving on time with a charged Chromebook!"}</Alert>
 <Box m={2}/>
 </React.Fragment>
: null 
}

{props.studentDataByDay[0].student_reference.grade_level === '7' ?
<Alert
severity={students_earning_bonus.includes(props.studentDataByDay[0].student_unique_id)? "success" : "error"}
>
{students_earning_bonus.includes(props.studentDataByDay[0].student_unique_id)? 
"You earned an extra 15 points for finishing up PFAs early in Dec! " 
: 
"You did not earn an extra 15 points for finishing up PFAs early in Dec"}
</Alert> 
: null}

<Box m={2}/>
{props.studentDataByDay[0].student_reference.school_name === 'Belmont MS' ?
<Alert
severity={students_earning_bonus_2.includes(props.studentDataByDay[0].student_unique_id)? "success" : "error"}
>
{students_earning_bonus_2.includes(props.studentDataByDay[0].student_unique_id)? 
"You earned an extra 5 points for coming to school on-time for NWEA testing days 1/30 and 1/31" 
: 
"You did not earn an extra 5 points for coming to school on-time for NWEA testing days 1/30 and 1/31"}
</Alert> 
: null}

<Box m={2}/>
</Grid2>
      <Grid2 id="no-streak-header" item xs={12}>
{/*         {!behaviorStreak || behaviorStreak <= 0 ? (
          <Alert
            style={{ marginBottom: "5%" }}
            severity="error"
            variant="filled"
          >
            <AlertTitle></AlertTitle>
            {true && props.studentDataByDay.length === 0
              ? null
              : "You have not earned any daily goal points since " +
                props.studentDataByDay
                  .filter(
                    (x) =>
                      x.onegoal_points > 0 &&
                      x.onegoal_points != null
                  )
                  .sort(
                    (a, b) =>
                      b.instructional_day.value.valueOf() -
                      a.instructional_day.value.valueOf()
                  )
                  .slice(-1)[0].instructional_day.value +
                " (" +
                Math.floor(
                  (new Date().getTime() -
                    new Date(
                      props.studentDataByDay
                        .filter(
                          (x) =>
                            x.onegoal_points > 0 &&
                            x.onegoal_points != null
                        )
                        .sort(
                          (a, b) =>
                            b.instructional_day.value.valueOf() -
                            a.instructional_day.value.valueOf()
                        )
                        .slice(-1)[0].instructional_day.value
                    ).getTime()) /
                    (1000 * 3600 * 24) -
                    1
                ) +
                " days ago)"}
          </Alert>
        ) : null} */}
      </Grid2>
      <Grid2 id="behavior goal" item xs={8} xl={8}>
        <Alert
          icon={<LooksOne />}
          style={{ textAlign: "left" }}
          variant="standard"
          severity="info"
        >
          <AlertTitle style={{ textAlign: "left" }}>
            {"Automatic EPIC Points"}
          </AlertTitle>
          {props.language === "english"
            ? `1 point per day if you attend school on time and don't earn any negative consequences`
            : `1 punto por día si asistes a la escuela a tiempo y no obtienes ninguna consecuencia negativa`}
        </Alert>
      </Grid2>
      <Grid2 id="behavior points earned" item xs={4} xl={4}>
        <div style={{ textAlign: "center" }}>
          <Typography variant="subtitle2">
            {props.language === "english" ? "Points" : "Puntos"}
          </Typography>
          <Typography variant="h3">
            <AnimatedNumbers
              animateToNumber={props.studentDataByDay
                .map((x) => parseInt(x.onegoal_points))
                .filter((x) => !Number.isNaN(x))
                .reduce((a, b) => a + b, 0)}
            />
          </Typography>

          {!behaviorStreak || behaviorStreak <= 0 ? null : (
            <Button
              onClick={handleClickBehavior}
              color="warning"
              variant="outlined"
              style={{ alignItems: "right" }}
            >
              <FireIcon
                fontSize={behaviorStreak > 9 ? "large" : "medium"}
                htmlColor="orange"
              />
              <Typography variant="h4">{behaviorStreak}</Typography>
            </Button>
          )}
          <Snackbar
            open={openBehavior}
            //autoHideDuration={10000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={"success"}
              sx={{ width: "100%" }}
            >
              {behaviorStreak > 1
                ? `${behaviorStreak} day long streak of good days; your points are doubling!   ` +
                  quotes[Math.floor(Math.random() * quotes.length)]
                : `Goal met!   ` +
                  quotes[Math.floor(Math.random() * quotes.length)]}
            </Alert>
          </Snackbar>
        </div>
      </Grid2>
      <Grid2 id="behavior heatmap" item xs={12} xl={12}>
        <HeatMap
          value={chartDataBehavior}
          width={"100%"}
          startDate={
            window.matchMedia("(max-width: 600px)").matches
              ? new Date("2024-01-01")
              : new Date("2024-01-01")
          }
          //autoReverse
          legendCellSize={20}
          //style={{ color: "#FFFFFF" }}
          //legendRender={}
          panelColors={{
            0: "#D3D3D3", //null
            1: "#ff0000", //null or no points earned
            2: "#0bb332", //light green
            3: "#0bb332", //intrinsic color
          }}
          endDate={new Date()}
          monthLabels={[
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ]}
          rectProps={{
            rx: 5,
          }}
          rectSize={20}
          rectRender={(props, data) => {
            return (
              <Tooltip
                key={data.date}
                placement="top"
                content={!data.status ? null : data.date + " " + data.status}
              >
                <rect
                  {...props}
                  onClick={() => {
                    console.log("selected data", data);
                    setSelected(data);
                    setSelectedTitle(
                      data.date === selected
                        ? ""
                        : `${format(new Date(data.date), "MMM d")}`
                    );
                  }}
                />
              </Tooltip>
            );
          }}
        />
      </Grid2>
      <Grid2 id="teacher assigned points info" item xs={8} xl={8}>
        <React.Fragment>
          <Box m={2} />
          <Alert
            style={{ textAlign: "left" }}
            variant="standard"
            severity="info"
            icon={<ThumbUpOffAlt />}
          >
            <AlertTitle style={{ textAlign: "left" }}>
              {props.language === "english"
                ? ` Intrinsic Community Assigned EPIC Points`
                : `Puntos EPIC asignados por la comunidad Intrinsic`}
            </AlertTitle>
          </Alert>
        </React.Fragment>
      </Grid2>
      <Grid2 id="teacher assigned points" item xs={4} xl={4}>
        <div style={{ textAlign: "center" }}>
          <Box m={2} />
          <Typography variant="h3">
            <AnimatedNumbers
              animateToNumber={props.studentDataByDay
                .filter(
                  (x) =>
                    !Number.isNaN(x.bonus_points) && x.bonus_points !== null
                )
                .map((x) => parseInt(x.bonus_points))
                .reduce((a, b) => a + b, 0)}
            />
          </Typography>
        </div>
      </Grid2>
      <Grid2 id="selected day data" item xs={12} xl={12}>
        {selected ? (
          <Alert
            onClose={() => {
              setSelected(null);
            }}
            severity={selected.count === 0 ? "error" : "success"}
            style={{ margin: "2em" }}
          >
            <AlertTitle>{selectedTitle}</AlertTitle>
            {selected.status}
          </Alert>
        ) : null}
      </Grid2>
      <Grid2 id="data last updated" item xs={12} xl={12}>
        <Box m={2} />

        <Typography variant="subtitle2" style={{ float: "left" }}>
          {`Data updates at night`}
          {/*           {
            [
              ...new Set(
                props.studentDataByDay
                  .map((x) => x.instructional_day.value)
                  .sort((a, b) => new Date(b) - new Date(a))
              ),
            ][0]
          } */}

          {/* 
          <Box m={2}/>
          {props.language === "english"
            ? `Data accessible by: `
            : `Datos accesibles por: `}
          <ul>
            {props.parentEmails.map((x) => (
              <li>{x.email_address}</li>
            ))}
          </ul> */}
        </Typography>
        <Box m={2} />
      </Grid2>


    </Grid2>
  );
}
